module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/dcar-score-black-7436ec471f5bd9344d405f66a5125e39.png";